import React from "react";

import { FileItem } from "types";

import { FileList } from "./FileList";
import { FileDropArea } from "./FileDropArea";

export interface DropzoneWithFileListProps {
    name: string;
    disabled?: boolean;
    maxUploadedFiles?: number;
    multiple?: boolean;
    onLoadFile?: (file: FileItem) => Promise<Partial<FileItem>>;
    onDeleteFile?: (file: FileItem) => Promise<void>;
}

export const FileDropAreaWithFileList: React.FC<DropzoneWithFileListProps> = ({
    name,
    disabled,
    maxUploadedFiles,
    multiple,
    onLoadFile,
    onDeleteFile,
}) => {
    return (
        <>
            <FileDropArea name={name} disabled={disabled} maxUploadedFiles={maxUploadedFiles} multiple={multiple} onLoadFile={onLoadFile} />
            <FileList name={name} disabled={disabled} onDeleteFile={onDeleteFile} displayWhenEmpty={false} />
        </>
    );
};
